module.exports = "/packs/mokumoku-study-room-image-5cb4d077d5bb0b06665878186c83ac86.png";